import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-c9329ed0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "version-update-wrap" }
const _hoisted_2 = { class: "upload-wrap" }
const _hoisted_3 = { class: "info-header" }
const _hoisted_4 = {
  key: 0,
  class: "upload-result"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "上次更新结果：", -1))
const _hoisted_6 = {
  key: 0,
  class: "stats-msg running"
}
const _hoisted_7 = {
  key: 1,
  class: "stats-msg succ"
}
const _hoisted_8 = { class: "cm-ui-ml20" }
const _hoisted_9 = {
  key: 2,
  class: "stats-msg fail"
}
const _hoisted_10 = { class: "cm-ui-ml20" }
const _hoisted_11 = { class: "el-upload__text" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-upload__text" }, [
  /*#__PURE__*/_createTextVNode(" 将文件拖到此处，或 "),
  /*#__PURE__*/_createElementVNode("span", { class: "cm-link-light" }, "点击添加")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CurrentVersion = _resolveComponent("CurrentVersion")!
  const _component_CascadeSetting = _resolveComponent("CascadeSetting")!
  const _component_CmSvgIcon = _resolveComponent("CmSvgIcon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_UploadDialog = _resolveComponent("UploadDialog")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_CurrentVersion),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createTextVNode("更新包 "),
        _createVNode(_component_CascadeSetting)
      ]),
      (_ctx.viewModel.taskStatus.task_status)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _hoisted_5,
            (_ctx.viewModel.taskStatus.task_status === _ctx.TASK_STATUS_OPTIONS.RUNNING)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, "更新中"))
              : _createCommentVNode("", true),
            (_ctx.viewModel.taskStatus.task_status === _ctx.TASK_STATUS_OPTIONS.SUCCESS)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                  _createTextVNode("更新成功"),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.viewModel.taskStatus.mtime), 1)
                ]))
              : _createCommentVNode("", true),
            ([_ctx.TASK_STATUS_OPTIONS.TIMEOUT,_ctx.TASK_STATUS_OPTIONS.FAIL].includes(_ctx.viewModel.taskStatus.task_status))
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                  _createTextVNode(" 更新失败 "),
                  (_ctx.viewModel.taskStatus.task_status === _ctx.TASK_STATUS_OPTIONS.FAIL)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(" ： " + _toDisplayString(_ctx.viewModel.taskStatus.msg), 1)
                      ], 64))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.viewModel.taskStatus.mtime), 1)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_el_upload, {
        class: "file-upload",
        ref: "uploadNode",
        drag: "",
        action: `${_ctx.getBaseUrl()}/upgrade/upload`,
        name: "file",
        accept: ".zip",
        limit: 1,
        "show-file-list": false,
        "auto-upload": false,
        "http-request": _ctx.handleHttpUpload,
        onChange: _ctx.handleChange,
        onSelect: _ctx.handleChange,
        onClick: _ctx.handleClick
      }, {
        default: _withCtx(() => [
          (_ctx.viewModel.fileName)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("i", null, [
                  _createVNode(_component_CmSvgIcon, {
                    name: "views/dashboard/setting/version-update/_images/zip",
                    class: "file-icon",
                    monochrome: ""
                  })
                ]),
                _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.viewModel.fileName), 1)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("i", null, [
                  _createVNode(_component_CmSvgIcon, {
                    name: "views/dashboard/setting/version-update/_images/add-file",
                    class: "file-icon",
                    monochrome: ""
                  })
                ]),
                _hoisted_12
              ], 64))
        ]),
        _: 1
      }, 8, ["action", "http-request", "onChange", "onSelect", "onClick"]),
      _createVNode(_component_el_button, {
        class: "cm-ui-mt15",
        size: "small",
        type: "primary",
        disabled: !_ctx.viewModel.uploadFile?.raw || _ctx.viewModel.taskStatus.task_status === _ctx.TASK_STATUS_OPTIONS.RUNNING,
        onClick: _ctx.handleSubmitUpload
      }, {
        default: _withCtx(() => [
          _createTextVNode(" 开始上传 ")
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ]),
    _createVNode(_component_el_dialog, {
      "append-to-body": "",
      title: "上传文件",
      modelValue: _ctx.viewModel.uploadDialog,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.viewModel.uploadDialog) = $event)),
      "close-on-click-modal": false,
      width: 470,
      "before-close": _ctx.resetUpload,
      "destroy-on-close": ""
    }, {
      footer: _withCtx(() => [
        (_ctx.viewModel.uploading === 1)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              class: "btn",
              size: "small",
              onClick: _ctx.resetUpload
            }, {
              default: _withCtx(() => [
                _createTextVNode("取 消")
              ]),
              _: 1
            }, 8, ["onClick"]))
          : (_openBlock(), _createBlock(_component_el_button, {
              key: 1,
              class: "btn",
              size: "small",
              type: "primary",
              onClick: _ctx.uploadDone
            }, {
              default: _withCtx(() => [
                _createTextVNode("确 定")
              ]),
              _: 1
            }, 8, ["onClick"]))
      ]),
      default: _withCtx(() => [
        _createVNode(_component_UploadDialog, {
          "error-msg": _ctx.viewModel.errorMsg,
          "file-name": _ctx.viewModel.fileName,
          percent: _ctx.viewModel.percentage,
          uploading: _ctx.viewModel.uploading
        }, null, 8, ["error-msg", "file-name", "percent", "uploading"])
      ]),
      _: 1
    }, 8, ["modelValue", "before-close"])
  ]))
}